/* eslint-disable @next/next/no-html-link-for-pages */
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { fetchSeoByPage } from "../lib/seoHelper";
import Seo from "../components/common/Seo";

const Booked = ({ meta }) => {
  const router = useRouter();
  const { saveBooking, message, detail, isPersonalChauffeur, planName, validTo } = router.query;

  const [failure, setFailure] = useState(null);

  useEffect(() => {
    if (typeof saveBooking === "string") {
      setFailure(saveBooking);
    }
  }, [saveBooking]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const isPC = Number(isPersonalChauffeur) === 1;
  const isSuccess = failure === "1";

  return (
    <>
      <Seo meta={meta} />
      <div className="btn btn-sucess-failure"></div>
      <div className="booking-succecc container">
        <h2 style={{ color: "#6DC8BF" }}>
          {isPC
            ? (planName ? "Booking Successful" : "Subscription Plan Activated Successfully")
            : "Book A Ride"}
        </h2>


        {isSuccess ? (
          <>
            <div className="image-tick">
              <img src="/img/cars/tick1.png" alt="Image Success" />
            </div>

            <h3>{isPC ? "Personal Chauffeur" : "Booking Successful"}</h3>

            <p className="text-center fw-bold">Your Trip ID : {detail}</p>

            {/* 🔹 Show plan name + validity only for Personal Chauffeur */}
            {isPC && (
              <>
                {planName && (
                  <p className="text-center fw-bold" style={{ margin: "4px 0px" }}>
                    Plan: {planName}
                  </p>
                )}
                {validTo && (
                  <p className="text-center" style={{ margin: "4px 0px" }}>
                    {validTo}
                  </p>
                )}
              </>
            )}

            <p className="text-center fw-bold" style={{ marginBottom: "4px" }}>{message}</p>
          </>
        ) : (
          <>
            <div className="image-tick"></div>
            <h3>Booking UnSuccessful</h3>
            <p className="text-center fw-bold">{message}</p>
          </>
        )}

        <a
          href={isPC ? "/personal-chauffeur" : "/"}
          style={{
            backgroundColor: "#6dc8bf",
            padding: "6px 12px",
            borderRadius: "12px",
          }}
        >
          {isPC ? "Go Back" : "Go Home"}
        </a>
      </div>
    </>
  );
};

export default Booked;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}